import styled from 'styled-components'
import { useShowDialog } from 'App'
import { theme } from 'styles/theme'
import { ButtonProps, PrimaryButton, SecondaryButton } from '../Button/Button'
import { Column, Row } from '../Table/Table'
import { BodyText, Heading1 } from '../Typography/Typography'
import ScreenGlass from '../ScreenGlass'

const StyledDialog = styled.div`
  display: inline-block;
  background: ${theme.colors.White};
  border-radius: ${theme.radii.medium};
  position: relative;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  min-width: 550px;
  padding: 3em;
`

export interface DialogProps {
  title?: string
  text?: string
  FooterComponent? : React.ReactNode
  confirmText?: string
  cancelText?: string
  content?: JSX.Element
  confirmButtonExtraProps?: Partial<ButtonProps>,
  onConfirmed?: VoidFunction | (() => Promise<never | any>)
  onCancelled?: VoidFunction | (() => Promise<never | any>)
}

export const Dialog = ({
  title,
  text,
  FooterComponent,
  content,
  confirmText = 'OK',
  cancelText = 'Cancel',
  onConfirmed,
  confirmButtonExtraProps,
  onCancelled,
}: DialogProps) => {
  const showDialog = useShowDialog()

  const hideDialog = () => { showDialog(null) }

  return (
    <ScreenGlass {...{ style: { zIndex: 300 } }}>
      <StyledDialog>
        <Column style={{ alignItems: 'center' }}>
          {content ?? (
            <>
              <Heading1>{title}</Heading1>
              <BodyText>{text}</BodyText>
              {FooterComponent}
            </>
          )}
          {(onCancelled || onConfirmed) && <Row style={{ marginTop: '2em', gap: '3em' }}>
            {onCancelled && <SecondaryButton {...{
              text: cancelText,
              // eslint-disable-next-line @typescript-eslint/no-misused-promises
              onClick: async () => {
                hideDialog()

                await onCancelled()
              }
            }} />}
            {onConfirmed && <PrimaryButton {...{
              text: confirmText,
              ...confirmButtonExtraProps,
              // eslint-disable-next-line @typescript-eslint/no-misused-promises
              onClick: async () => {
                hideDialog()

                await onConfirmed()
              }
            }} />}
          </Row>}
        </Column>
      </StyledDialog>
    </ScreenGlass>
  )
}